module.exports = __webpack_public_path__ + "img/30581433000149.baf3b7dd.png";